module.exports = __webpack_public_path__ + "static/img/emmanuel.fc59e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emmanuel.png
// module id = 7prr
// module chunks = 0